skrilla.service('adminService', function(searchService, $window){
    let admin;
    let getAdmin = function(overide){
        if(admin === undefined || overide){
            //We do this here as getAdmin is always called on load, and get admin happens before auth attempt
            //URLSearchParams doesn't work well with ?. Also makes cleaning up the href easier.
            let url = window.location.hash.replace("?", "&");
            let token = new URLSearchParams(url).get("token");
            if(token){
                $window.localStorage.token = "Bearer " + token;
                //do this bit slowly as to avoid race condition
                setTimeout(function(){
                    //this feels dirty but hopefully wont be here for long
                    let newUrl = window.location.hash
                        .replace(`?token=${token}`, "?")
                        .replace(`&token=${token}`, "");
                    window.location.href = newUrl
                }, 1000)

            }
            searchService.get('admins/me').then(function(response) {
                admin = response.data.admin;
                admin.roles = response.data.role && response.data.role.permissions;
                admin.fullName = response.data.username;
                admin.email = response.data.email;
            })
              .catch(error => {
                  console.log("Error getting current admin details", error);
              });
        }
        else{
            return admin;
        }
    }
    getAdmin();
    let hasRole = function(role){
        return admin && admin.roles && $window.localStorage.token && admin.roles.find(it => it === role)
    }

    let isLoggedIn = function(){ return $window.localStorage.token !== undefined;}

    return {
        getAdmin: getAdmin,
        hasRole: hasRole,
        isLoggedIn: isLoggedIn
    };
});

